/* eslint-disable react/prop-types */
import { Row, Spin } from 'antd';
import Table from 'components/Table';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { checkToken } from 'api/utils';
import { getNombramientosSinPaginar } from 'api/catalogos/Nombramientos';

export const nombramientosEmpleadoPermission = {
  permissionModel: 'nombramiento',
  catalogsModels: [],
  tabsModels: [],
};

const NombramientosEmpleado = ({ empleadoId, permission }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      if (!empleadoId) {
        setData([]);
        return;
      }
      setLoading(true);
      await checkToken();
      const response = await getNombramientosSinPaginar({ empleado: empleadoId });
      if (mounted) {
        const list = response?.results || response || [];
        setData(list);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, [empleadoId]);

  const columns = [
    {
      titleText: 'Folio',
      dataIndex: 'folio',
      key: 'folio',
      width: 140,
      render: (val) => val || '-',
    },
    {
      titleText: 'Carácter de Nombramiento',
      dataIndex: 'descripcion_caracter_de_nombramiento',
      key: 'descripcion_caracter_de_nombramiento',
      width: 250,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'descripcion_puesto',
      key: 'descripcion_puesto',
      width: 280,
    },
    {
      titleText: 'Inicio de Vigencia',
      dataIndex: 'inicio_vigencia',
      key: 'inicio_vigencia',
      width: 150,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : '-'),
    },
    {
      titleText: 'Término de Vigencia',
      dataIndex: 'termino_de_vigencia',
      key: 'termino_de_vigencia',
      width: 160,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : '-'),
    },
    {
      titleText: 'Estado',
      dataIndex: 'descripcion_estado_de_nombramiento',
      key: 'descripcion_estado_de_nombramiento',
      width: 180,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={{
            selectedRowKeys,
            type: 'radio',
          }}
          handleOnRowClick={(record) => setSelectedRowKeys([record.id])}
          permission={permission}
          allowImport={false}
          allowExportPDF={false}
          controls={{}}
        />
      </Spin>
    </Row>
  );
};

export default NombramientosEmpleado;
